import React from 'react';
import { waLink, trackLead } from '../lib/whatsapp';
import { cn } from '../lib/utils';

// Botão primário único da página. Toda ação de conversão passa por aqui.
// Forma: botões são sempre pill; cards 16px; campos 12px.
const WhatsAppCTA = ({ message, source, children, size = 'lg', variant = 'solid', className, testid }) => (
  <a
    href={waLink(message)}
    target="_blank"
    rel="noopener noreferrer"
    onClick={() => trackLead(source)}
    data-testid={testid}
    className={cn(
      'inline-flex items-center justify-center whitespace-nowrap rounded-full font-semibold',
      'transition-[transform,background-color,color] duration-200 active:scale-[0.98]',
      'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent',
      variant === 'solid'
        ? 'bg-accent text-accent-ink hover:-translate-y-px hover:bg-accent/90'
        : 'border border-line text-ink hover:border-ink/40',
      size === 'lg' ? 'px-7 py-4 text-base' : 'px-5 py-2.5 text-sm',
      className
    )}
  >
    {children}
  </a>
);

export default WhatsAppCTA;
